export const menuOpenConstants = {
  TOGGLE: 'TOGGLE_MENU',
}
